import React, { Component } from "react";


class EducationRight extends Component {
  constructor(props) {
    super(props);
    this.state = {
      skill: [
        {
          id: 1,
          timeline: "timeline-inverted color1",
          info: "Just IT",
          title: "Software and Web development level 3 Qualification",
          text: "Covering: HTML, CSS, JAVASCRIPT & Python"
        },
        
        {
          id: 2,
          timeline: "timeline-inverted color1",
          info: "Avanade",
          title: "Software and Web Development Internship Experience",
          text: "Covering: C# & SQL"
        },
        

        {
          id: 3,
          timeline: "timeline-inverted color1", 
          info: "Higher Degree",
          title: "Professional Diploma/Qualification IAL Sardegna(Italy)",
          text: "Covering: English & Maths, Science, History, Italian, Professional Skills and more...",
        },
      ],
    };
  }
  render() {
    return (
      <div className="col-right">
        <div
          className="flat-spacer"
          data-desktop={0}
          data-mobile={70}
          data-smobile={70}
        />
        <div className="flat-title t1 animate-element wow delay5 fadeInDown">
          <h4 className="sub-title mg-b13">Educational qualification</h4>
          <h2 className="title-section color-d12">My Education</h2>
        </div>
        <div
          className="timelines position-relative animate-element wow delay5 fadeInUp"
          data-wow-delay="0.5s"
        >
          <ul className="timeline">
            {this.state.skill.map((data) => (
              <li className={data.timeline} key={data.id}>
                <div className="timeline-badge" />
                <div className="timeline-panel">
                  <h3 className="f-info">{data.info}</h3>
                  <div className="s-info">{data.title}</div>
                  <p>{data.text}</p>
                </div>
              </li>
            ))}
          </ul>
        
        </div>
      </div>
    );
  }
}

export default EducationRight;
